import styled from 'styled-components';
import { Avatar, Progress, Button, Skeleton } from 'antd';
import { ClockCircleOutlined, EyeOutlined } from '@ant-design/icons';
import { getDateTime } from '../../utils';
import { getSize, Heading4, SecondaryText, SupportText, getColor, primitives, styleVariables, SecondaryButton, HeightSpacer } from '@lib/common';
import { AttendeeSubmissionStatusComponent, getTranslatedSubmissionStatusKey } from '../../attendee-submission-status';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var md5 = function md5(str) {
  var hash = 0;

  for (var i = 0; i < str.length; i++) {
    var _char = str.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash = hash & hash;
  }

  return Math.abs(hash).toString(16);
};

var getSubmissionStatusTranslationName = function getSubmissionStatusTranslationName(attendeeTranslation, attendee) {
  var _ref, _attendeeTranslation$;

  var submissionStatusTranslationKeys = {
    submissionStatusOnGoing: attendeeTranslation.statusOnGoing,
    submissionStatusBanned: attendeeTranslation.statusBanned,
    submissionStatusPassed: attendeeTranslation.passed,
    submissionStatusFailed: attendeeTranslation.failed,
    submissionStatusSubmitted: (_ref = (_attendeeTranslation$ = attendeeTranslation.submissionStatusSubmitted) !== null && _attendeeTranslation$ !== void 0 ? _attendeeTranslation$ : attendeeTranslation.statusSubmitted) !== null && _ref !== void 0 ? _ref : '',
    submissionStatusNone: ''
  };
  return submissionStatusTranslationKeys[getTranslatedSubmissionStatusKey(attendee)];
};

var StyledCardWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledCardWrapper",
  componentId: "sc-hn6l0e-0"
})(["background:", ";border-radius:", ";border:1px solid ", ";padding:24px;display:flex;align-items:center;gap:20px;margin-bottom:16px;transition:box-shadow 0.3s ease;&:hover{box-shadow:0 4px 12px rgba(0,0,0,0.15);}"], getColor('fillBgWhite'), getSize('radiusSm'), styleVariables.colors.gray9);
var StyledWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledWrapper",
  componentId: "sc-hn6l0e-1"
})(["display:flex;flex-direction:column;align-items:center;gap:12px;"]);
var StyledAboveWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledAboveWrapper",
  componentId: "sc-hn6l0e-2"
})(["display:flex;align-items:center;justify-content:center;flex:1;"]);
var StyledInfoSection = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledInfoSection",
  componentId: "sc-hn6l0e-3"
})(["flex:1;display:flex;flex-direction:column;"]);
var StyledName = styled(Heading4).withConfig({
  displayName: "attendee-cardcomponent__StyledName",
  componentId: "sc-hn6l0e-4"
})([""]);
var StyledEmail = styled(SecondaryText).withConfig({
  displayName: "attendee-cardcomponent__StyledEmail",
  componentId: "sc-hn6l0e-5"
})([""]);
var StyledTimeStamp = styled(SupportText).withConfig({
  displayName: "attendee-cardcomponent__StyledTimeStamp",
  componentId: "sc-hn6l0e-6"
})(["display:flex;align-items:center;gap:6px;.anticon{font-size:", ";}"], getSize('typo14'));
var StyledScoreSection = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledScoreSection",
  componentId: "sc-hn6l0e-7"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;"]);
var StyledViolateWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledViolateWrapper",
  componentId: "sc-hn6l0e-8"
})(["border-left:1px solid ", ";"], getColor('fillIntSubActive'));
var StyledScoreLabel = styled(SupportText).withConfig({
  displayName: "attendee-cardcomponent__StyledScoreLabel",
  componentId: "sc-hn6l0e-9"
})(["text-transform:uppercase;letter-spacing:1px;"]);
var StyledScoreValue = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledScoreValue",
  componentId: "sc-hn6l0e-10"
})(["font-size:", ";font-weight:700;color:", ";"], getSize('typo24'), getColor('fillIntActive'));
var StyledGradingSection = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledGradingSection",
  componentId: "sc-hn6l0e-11"
})(["display:flex;flex-direction:column;align-items:center;min-width:180px;border-left:1px solid ", ";padding-left:16px;"], getColor('fillIntSubActive'));
var StyledProgressWrapper = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledProgressWrapper",
  componentId: "sc-hn6l0e-12"
})(["display:flex;align-items:center;gap:12px;"]);
var GradingLabel = styled(SupportText).withConfig({
  displayName: "attendee-cardcomponent__GradingLabel",
  componentId: "sc-hn6l0e-13"
})(["text-transform:uppercase;letter-spacing:1px;margin-bottom:8px;"]);
var StyledProgressBar = styled.div.withConfig({
  displayName: "attendee-cardcomponent__StyledProgressBar",
  componentId: "sc-hn6l0e-14"
})(["width:120px;margin-bottom:4px;"]);
var StyledPercentageText = styled(SecondaryText).withConfig({
  displayName: "attendee-cardcomponent__StyledPercentageText",
  componentId: "sc-hn6l0e-15"
})(["font-weight:600;color:", ";"], function (props) {
  return props.color || primitives.green[5];
});

var buttonTextGradingOrReview = function buttonTextGradingOrReview(attendee, attendeeTranslation) {
  if (attendee.report.gradedPercentage < 100) {
    return attendeeTranslation.attendeeNeedToBeGrading;
  } else {
    return attendeeTranslation.attendeeNeedToReview;
  }
};

export var AttendeeCard = function AttendeeCard(_ref2) {
  var _attendee$report, _attendeeTranslation$2, _report$score;

  var attendee = _ref2.attendee,
      onOpenAttendeeSubmission = _ref2.onOpenAttendeeSubmission,
      onOpenViolateDetailModal = _ref2.onOpenViolateDetailModal,
      isReloading = _ref2.isReloading,
      attendeeTranslation = _ref2.attendeeTranslation,
      assignmentDuration = _ref2.assignmentDuration,
      _ref2$hideGradingStat = _ref2.hideGradingStatus,
      hideGradingStatus = _ref2$hideGradingStat === void 0 ? false : _ref2$hideGradingStat,
      _ref2$isGradingInProg = _ref2.isGradingInProgress,
      isGradingInProgress = _ref2$isGradingInProg === void 0 ? false : _ref2$isGradingInProg,
      gradingAttendeeId = _ref2.gradingAttendeeId;
  var name = "".concat(attendee.firstName, " ").concat(attendee.lastName);
  var email = attendee.email || 'No email provided';
  var report = attendee.report;
  var timeTakenMinutes = typeof assignmentDuration === 'number' ? report.getTimeTakenMinutes(assignmentDuration) : null;
  var avatarUrl = attendee.email ? "https://www.gravatar.com/avatar/".concat(md5(attendee.email), "?d=identicon") : undefined;
  var isCurrentAttendeeBeingGraded = isGradingInProgress && gradingAttendeeId === attendee.id.toString();

  var getProgressColor = function getProgressColor(percentage) {
    if (percentage === 100) return '#52c41a';
    if (percentage >= 75) return '#1890ff';
    if (percentage >= 50) return '#faad14';
    return '#ff4d4f';
  };

  var progressColor = getProgressColor(report.gradedPercentage || 0);

  if (isReloading) {
    return /*#__PURE__*/_jsxs(StyledCardWrapper, {
      children: [/*#__PURE__*/_jsx(Skeleton.Avatar, {
        active: true,
        size: 64,
        shape: "circle"
      }), /*#__PURE__*/_jsxs(StyledInfoSection, {
        style: {
          flex: 1
        },
        children: [/*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '50%',
            marginBottom: 8
          }
        }), /*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '30%'
          }
        })]
      }), /*#__PURE__*/_jsxs(StyledWrapper, {
        style: {
          flex: 1,
          alignItems: 'flex-start'
        },
        children: [/*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '80px',
            marginBottom: 12
          }
        }), /*#__PURE__*/_jsx(Skeleton.Input, {
          active: true,
          style: {
            width: '120px'
          }
        })]
      })]
    });
  }

  return /*#__PURE__*/_jsxs(StyledCardWrapper, {
    children: [/*#__PURE__*/_jsx(Avatar, {
      size: 64,
      src: avatarUrl,
      children: name === null || name === void 0 ? void 0 : name.charAt(0)
    }), /*#__PURE__*/_jsxs(StyledInfoSection, {
      children: [/*#__PURE__*/_jsx(StyledName, {
        children: name
      }), /*#__PURE__*/_jsx(StyledEmail, {
        children: email
      }), /*#__PURE__*/_jsxs(StyledTimeStamp, {
        children: [/*#__PURE__*/_jsx(ClockCircleOutlined, {}), report.submitTime ? getDateTime(+report.submitTime) : '-', /*#__PURE__*/_jsx(StyledViolateWrapper, {
          children: onOpenViolateDetailModal && ((_attendee$report = attendee.report) === null || _attendee$report === void 0 ? void 0 : _attendee$report.isViolatedSecurityOptions) && /*#__PURE__*/_jsx(Button, {
            type: "link",
            danger: true,
            onClick: function onClick() {
              return onOpenViolateDetailModal(attendee);
            },
            children: attendeeTranslation.viewViolationDetails
          })
        })]
      }), timeTakenMinutes != null && timeTakenMinutes > 0 && /*#__PURE__*/_jsxs(StyledTimeStamp, {
        children: [attendeeTranslation.timeTaken, ": ", timeTakenMinutes, ' ', (_attendeeTranslation$2 = attendeeTranslation.minutesShort) !== null && _attendeeTranslation$2 !== void 0 ? _attendeeTranslation$2 : 'mins']
      })]
    }), /*#__PURE__*/_jsx(StyledWrapper, {
      children: report.gradedPercentage ? /*#__PURE__*/_jsxs(StyledAboveWrapper, {
        style: hideGradingStatus && !onOpenAttendeeSubmission ? {
          justifyContent: 'flex-end'
        } : {},
        children: [/*#__PURE__*/_jsxs(StyledScoreSection, {
          children: [/*#__PURE__*/_jsx(StyledScoreLabel, {
            children: attendeeTranslation.score
          }), isCurrentAttendeeBeingGraded ? /*#__PURE__*/_jsx(Skeleton.Input, {
            active: true,
            style: {
              width: '60px',
              height: '32px'
            }
          }) : /*#__PURE__*/_jsx(StyledScoreValue, {
            children: ((_report$score = report.score) === null || _report$score === void 0 ? void 0 : _report$score.toFixed(1)) || null
          }), /*#__PURE__*/_jsx(HeightSpacer, {
            size: 12
          }), /*#__PURE__*/_jsx(AttendeeSubmissionStatusComponent, {
            attendee: attendee,
            text: getSubmissionStatusTranslationName(attendeeTranslation, attendee)
          })]
        }), (!hideGradingStatus || onOpenAttendeeSubmission) && /*#__PURE__*/_jsxs(StyledGradingSection, {
          children: [!hideGradingStatus && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(GradingLabel, {
              children: attendeeTranslation.gradingStatus
            }), /*#__PURE__*/_jsxs(StyledProgressWrapper, {
              children: [isCurrentAttendeeBeingGraded ? /*#__PURE__*/_jsx(Skeleton.Input, {
                active: true,
                style: {
                  width: '120px',
                  height: '8px'
                }
              }) : /*#__PURE__*/_jsx(StyledProgressBar, {
                children: /*#__PURE__*/_jsx(Progress, {
                  percent: report.gradedPercentage || 0,
                  strokeColor: progressColor,
                  showInfo: false,
                  strokeWidth: 8
                })
              }), isCurrentAttendeeBeingGraded ? /*#__PURE__*/_jsx(Skeleton.Input, {
                active: true,
                style: {
                  width: '35px',
                  height: '14px'
                }
              }) : /*#__PURE__*/_jsxs(StyledPercentageText, {
                color: progressColor,
                children: [report.gradedPercentage || 0, "%"]
              })]
            })]
          }), onOpenAttendeeSubmission && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(HeightSpacer, {
              size: 16
            }), /*#__PURE__*/_jsxs(SecondaryButton, {
              onClick: function onClick() {
                return onOpenAttendeeSubmission(attendee);
              },
              children: [/*#__PURE__*/_jsx(EyeOutlined, {}), attendeeTranslation.clickToViewDetail]
            })]
          })]
        })]
      }) : /*#__PURE__*/_jsx(StyledAboveWrapper, {
        children: /*#__PURE__*/_jsxs(StyledGradingSection, {
          children: [/*#__PURE__*/_jsx(GradingLabel, {
            children: attendeeTranslation.result
          }), /*#__PURE__*/_jsx(StyledProgressWrapper, {
            children: /*#__PURE__*/_jsx(AttendeeSubmissionStatusComponent, {
              attendee: attendee,
              text: getSubmissionStatusTranslationName(attendeeTranslation, attendee)
            })
          }), onOpenAttendeeSubmission && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(HeightSpacer, {
              size: 16
            }), /*#__PURE__*/_jsxs(SecondaryButton, {
              onClick: function onClick() {
                return onOpenAttendeeSubmission(attendee);
              },
              children: [/*#__PURE__*/_jsx(EyeOutlined, {}), attendeeTranslation.clickToViewDetail]
            })]
          })]
        })
      })
    })]
  });
};